// Number.prototype.toFixed returns scientific notation (e.g. "1e+38") for
// values >= 1e21. Override it once here so every call-site in the app gets
// a plain decimal string regardless of magnitude.
const _origToFixed = Number.prototype.toFixed;

Number.prototype.toFixed = function (this: number, fractionDigits?: number): string {
  const result = _origToFixed.call(this, fractionDigits);
  if (!result.includes('e') && !result.includes('E')) return result;

  // Reconstruct a full decimal string from the number's exponential form.
  const places = fractionDigits ?? 0;
  const [coeff, expStr] = this.toExponential().split('e');
  const exp = parseInt(expStr);
  const sign = this < 0 ? '-' : '';
  const [intPart, fracPart = ''] = coeff.replace('-', '').split('.');
  const digits = intPart + fracPart;
  const intEnd = exp + 1;
  const fullInt = intEnd >= digits.length
    ? digits + '0'.repeat(intEnd - digits.length)
    : digits.slice(0, intEnd);
  return sign + fullInt + (places > 0 ? '.' + '0'.repeat(places) : '');
};
